import type { GestureResponderEvent } from 'react-native'
import { Button, type IButtonProps } from '~/components/button'

import { useInputCreditCardProps } from '../../hooks'
import type { TInputCreditCardSizes } from '../../types'
import * as Comp from './input-credit-card-button.styles'

export function InputCreditCardButton({
  onPress,
  testID,
  ...props
}: Omit<IButtonProps, 'children'>) {
  const {
    size = 'md',
    isActive,
    isFilled,
    onChangeText,
  } = useInputCreditCardProps()

  const iconSizeMapping: Record<TInputCreditCardSizes, IButtonProps['size']> = {
    md: 'md',
    ml: 'ml',
    lg: 'ml',
    xl: 'ml',
  }

  function handlePress(event: GestureResponderEvent) {
    onChangeText?.('')
    onPress?.(event)
  }

  if (!isFilled) return null
  return (
    <Comp.Button isActive={!isFilled || isActive === false}>
      <Button.Root
        {...props}
        variant="neutral-tertiary"
        size={iconSizeMapping[size]}
        onPressIn={handlePress}
        onPressOut={handlePress}
        testID={testID}
      >
        <Button.Icon symbol="rdicon-dismiss-circle-outline" />
      </Button.Root>
    </Comp.Button>
  )
}
